import Cookies from "js-cookie";

const state = {
    skuCreateDialog: false,
    skuUpdateDialog: false,
    unitCreateDialog: false,
    priceTypeCreateDialog: false,
    attributeCreateDialog: false,
    promoActionTagCreateDialog: false,
    skuForm: null,
    productId: Cookies.get('productId'),
    updateId:Cookies.get('updateId'),
    iconCreateDialog: false,
    iconDialog: false,
    articleTagCreateDialog: false,
    faqSectionId: Cookies.get('faqSectionId'),
    faqCreateDialog: false,
    faqUpdateDialog:false,
    emailDialog: false,
    presetId: Cookies.get('presetId'),
    presetItemCreateDialog: false,
    popularItemCreateDialog: false,
    presetItemUpdateDialog: false,
    popularItemUpdateDialog: false,
    filled:null,
    showProductsDialog: false,
    showMainSlidesDialog: false,
    showCatalogSectionDialog: false,
    showProductsGiftDialog: false,
    showOrderStatusDialog: false,
    showOrderPaymentTypeDialog:false,
    showOrderDeliveryInfoDialog:false,
    showOrderProfileDialog: false,
    showOrderSkusDialog: false,
    faqSection: null,
}

// getters
const getters = {
    skuCreateDialog: state => state.skuCreateDialog,
    unitCreateDialog: state => state.unitCreateDialog,
    priceTypeCreateDialog: state => state.priceTypeCreateDialog,
    attributeCreateDialog: state => state.attributeCreateDialog,
    skuForm: state => state.skuForm,
    productId: state => state.productId,
    updateId: state => state.updateId,
    skuUpdateDialog: state => state.skuUpdateDialog,
    promoActionTagCreateDialog: state => state.promoActionTagCreateDialog,
    iconCreateDialog: state => state.iconCreateDialog,
    iconDialog: state => state.iconDialog,
    articleTagCreateDialog: state => state.articleTagCreateDialog,
    faqSectionId: state => state.faqSectionId,
    faqCreateDialog: state => state.faqCreateDialog,
    faqUpdateDialog: state => state.faqUpdateDialog,
    emailDialog: state => state.emailDialog,
    presetId: state => state.presetId,
    presetItemCreateDialog: state => state.presetItemCreateDialog,
    popularItemCreateDialog: state => state.popularItemCreateDialog,
    presetItemUpdateDialog: state => state.presetItemUpdateDialog,
    popularItemUpdateDialog: state => state.popularItemUpdateDialog,
    filled: state => state.filled,
    showProductsDialog: state => state.showProductsDialog,
    showMainSlidesDialog: state => state.showMainSlidesDialog,
    showCatalogSectionDialog: state => state.showCatalogSectionDialog,
    showProductsGiftDialog: state => state.showProductsGiftDialog,
    showOrderStatusDialog: state => state.showOrderStatusDialog,
    showOrderPaymentTypeDialog: state => state.showOrderPaymentTypeDialog,
    showOrderDeliveryInfoDialog: state => state.showOrderDeliveryInfoDialog,
    showOrderProfileDialog: state => state.showOrderProfileDialog,
    showOrderSkusDialog: state => state.showOrderSkusDialog,
    faqSection: state => state.faqSection
}

// mutations
const mutations = {
    skuCreateDialog: (state, payload) => {
        state.skuCreateDialog = payload;
    },
    unitCreateDialog: (state, payload) => {
        state.unitCreateDialog = payload;
    },
    priceTypeCreateDialog: (state, payload) => {
        state.priceTypeCreateDialog = payload;
    },
    attributeCreateDialog: (state, payload) => {
        state.attributeCreateDialog = payload;
    },
    skuForm: (state, payload) => {
        state.skuForm = payload;
    },
    productId: (state, payload,remember) => {
        state.productId = payload;
        Cookies.set('productId', payload, { expires: remember ? 365 : null })
    },
    faqSectionId: (state, payload,remember) => {
        state.faqSectionId = payload;
        Cookies.set('faqSectionId', payload, { expires: remember ? 365 : null })
    },
    updateId: (state, payload) => {
        state.updateId = payload;
    },
    skuUpdateDialog: (state, payload) => {
        state.skuUpdateDialog = payload;
    },
    promoActionTagCreateDialog: (state, payload) => {
        state.promoActionTagCreateDialog = payload;
    },
    iconCreateDialog: (state, payload) => {
        state.iconCreateDialog = payload;
    },
    iconDialog: (state, payload) => {        
        state.iconDialog = payload;        
    },
    articleTagCreateDialog: (state, payload) => {
        state.articleTagCreateDialog = payload;
    },
    faqCreateDialog: (state, payload) => {
        state.faqCreateDialog = payload;
    },
    faqUpdateDialog: (state, payload) => {
        state.faqUpdateDialog = payload;
    },
    emailDialog: (state, payload) => {
        state.emailDialog = payload;
    },
    presetId: (state, payload) => {
        state.presetId = payload;
        Cookies.set('presetId', payload);
    },
    presetItemCreateDialog: (state, payload) => {
        state.presetItemCreateDialog = payload;
    },
    popularItemCreateDialog: (state, payload) => {
        state.popularItemCreateDialog = payload;
    },
    presetItemUpdateDialog: (state, payload) => {
        state.presetItemUpdateDialog = payload;
    },
    popularItemUpdateDialog: (state, payload) => {
        state.popularItemUpdateDialog = payload;
    },
    filled: (state, payload) => {
        state.filled = payload;
    },
    showCatalogSectionDialog: (state, payload) => {
        state.showCatalogSectionDialog = payload
    },
    showProductsDialog: (state, payload) => {
        state.showProductsDialog = payload;
    },
    showMainSlidesDialog: (state, payload) => {
        state.showMainSlidesDialog = payload;
    },
    showProductsGiftDialog: (state, payload) => {
        state.showProductsGiftDialog = payload;
    },
    showOrderStatusDialog: (state, payload) => {
        state.showOrderStatusDialog = payload;
    },
    showOrderPaymentTypeDialog: (state, payload) => {
        state.showOrderPaymentTypeDialog = payload;
    },
    showOrderDeliveryInfoDialog: (state, payload) => {
        state.showOrderDeliveryInfoDialog = payload;
    },
    showOrderProfileDialog: (state, payload) => {
        state.showOrderProfileDialog = payload;
    },
    showOrderSkusDialog:(state, payload) => {
        state.showOrderSkusDialog = payload;
    },
    faqSection:(state, payload) => {
        state.faqSection = payload
    }
}

// actions
const actions = {

}
export default {
    state,
    getters,
    mutations,
    actions,
};
